module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "vote_index",
    staticClass: "vote_index"
  }, [_c('div', {
    staticClass: "vote_index_top"
  }, [_c('div', {
    staticClass: "vote_top"
  }, [_vm._v("已有"), _c('span', [_vm._v(_vm._s(this.schoolNum))]), _vm._v("所高校"), _c('span', [_vm._v(_vm._s(this.coursesNum))]), _vm._v("部课程参赛评选，"), _c('span', [_vm._v(_vm._s(_vm.stuNum.value) + _vm._s(_vm.stuNum.unit))]), _vm._v("名学生总计投票"), _c('span', [_vm._v(_vm._s(_vm.voteNum.value) + _vm._s(_vm.voteNum.unit))]), _vm._v("次")]), _vm._v(" "), _c('ul', {
    staticClass: "tab_box"
  }, _vm._l((this.categoryData), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        act: (_vm.isActive == item.category ? true : false)
      },
      on: {
        "click": function($event) {
          _vm.tabchange(item.category);
          _vm.isActive = item.category;
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.value) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "vote_index_icon left_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "vote_index_icon right_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "vote_index_fg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "vote_center"
  }, [_c('div', {
    staticClass: "vote_search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "maxlength": "50",
      "placeholder": "按高校名称进行搜索"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search_btn",
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), (this.length > 0) ? _c('div', {
    staticClass: "vote_list_box"
  }, _vm._l((this.coursesData.courses), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "vote_list"
    }, [_c('img', {
      staticClass: "vote_img",
      attrs: {
        "src": item.img
      },
      on: {
        "click": function($event) {
          return _vm.videoDetail(item.video_url)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "vote_name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "vote_id"
    }, [_vm._v("视频ID："), _c('label', [_vm._v(_vm._s(item.id))])]), _vm._v(" "), _c('p', {
      staticClass: "vote_org"
    }, [_vm._v(_vm._s(item.org))]), _vm._v(" "), _c('p', {
      staticClass: "vote_msg"
    }, [_c('span', {
      staticClass: "vote_msg_l"
    }, [_vm._v("总评分："), _c('label', [_vm._v(_vm._s(item.score))]), _vm._v("分")]), _c('span', {
      staticClass: "vote_msg_r"
    }, [_vm._v("总投票："), _c('label', [_vm._v(_vm._s(item.vote))]), _vm._v("人")])]), _vm._v(" "), _c('div', {
      staticClass: "vote_btn vote_over_btn"
    }, [_vm._v("投票已结束")])])
  }), 0) : _c('div', {
    staticClass: "list_null"
  }, [_vm._v("暂无数据！！！")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.length > 0),
      expression: "this.length>0"
    }],
    staticClass: "page_box"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "pager",
      "page-size": 12,
      "total": this.nums
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频预览",
      "visible": _vm.videoPop,
      "width": "550px",
      "top": "200px",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoPop = $event
      },
      "close": _vm.closeVideoPop
    }
  }, [(_vm.videoUrl) ? _c('div', {
    staticClass: "video_box"
  }, [_c('video', {
    attrs: {
      "id": "video",
      "width": "500",
      "height": "350",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": this.videoUrl,
      "type": "video/mp4"
    }
  }), _vm._v("\n        您的浏览器不支持 video 标签。\n      ")])]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "课程投票",
      "visible": _vm.votePop,
      "width": "550px",
      "top": "200px",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.votePop = $event
      },
      "close": _vm.closeVotePop
    }
  }, [(_vm.videoUrl) ? _c('div', {
    staticClass: "video_box"
  }, [_c('video', {
    attrs: {
      "id": "vote_video",
      "width": "500",
      "height": "350",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": this.videoUrl,
      "type": "video/mp4"
    }
  }), _vm._v("\n        您的浏览器不支持 video 标签。\n      ")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "vote_list"
  }, [_c('li', [_c('span', [_vm._v("课程内容")]), _vm._v(" "), _c('div', {
    staticClass: "star_box"
  }, [_c('el-rate', {
    attrs: {
      "max": 3,
      "disabled": _vm.isVote != 0
    },
    on: {
      "change": _vm.changeAscore
    },
    model: {
      value: (_vm.a_score_val),
      callback: function($$v) {
        _vm.a_score_val = $$v
      },
      expression: "a_score_val"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', [_vm._v("讲师表现")]), _vm._v(" "), _c('div', {
    staticClass: "star_box"
  }, [_c('el-rate', {
    attrs: {
      "max": 3,
      "disabled": _vm.isVote != 0
    },
    on: {
      "change": _vm.changeBscore
    },
    model: {
      value: (_vm.b_score_val),
      callback: function($$v) {
        _vm.b_score_val = $$v
      },
      expression: "b_score_val"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', [_vm._v("拍摄质量")]), _vm._v(" "), _c('div', {
    staticClass: "star_box"
  }, [_c('el-rate', {
    attrs: {
      "max": 3,
      "disabled": _vm.isVote != 0
    },
    on: {
      "change": _vm.changeCscore
    },
    model: {
      value: (_vm.c_score_val),
      callback: function($$v) {
        _vm.c_score_val = $$v
      },
      expression: "c_score_val"
    }
  })], 1)])]), _vm._v(" "), (_vm.vote_state == 0) ? _c('div', {
    staticClass: "pop_vote_btn",
    on: {
      "click": function($event) {
        return _vm.useVote(_vm.a_score_val, _vm.b_score_val, _vm.c_score_val)
      }
    }
  }, [_vm._v("投票")]) : (_vm.vote_state == 1) ? _c('div', {
    staticClass: "pop_vote_btn_over"
  }, [_vm._v("已投票")]) : (_vm.vote_state == 2) ? _c('div', {
    staticClass: "pop_vote_btn_over"
  }, [_vm._v("投票已达3000人上限")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c302b0b8"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/vote.vue
// module id = 504
// module chunks = 1